/* eslint-disable */

import Flickity from 'flickity';

(function() {
	/***
	 *	FULL WIDTH SLIDER - Used on staying, eating
	 *	Still using Owl Carousel
	 ***/
	$('body').imagesLoaded(function() {
		$('.basic-carousel').owlCarousel({
			singleItem: true,
			responsive: true,
			navigation: true,
			pagination: false,
			autoHeight: false,
			navigationText: ['<i></i>', '<i></i>']
		});
	});

	$('#primary-slider .owl-carousel').owlCarousel({
		singleItem: true,
		responsive: true,
		navigation: true,
		pagination: false,
		navigationText: false,
		autoHeight: false,
		navigationText: ['<i></i>', '<i></i>']
	});

	var primary = $('#primary-slider .owl-carousel, #multi-block-slider .owl-carousel').data('owlCarousel');

	$('.multi-block-slider .owl-carousel').owlCarousel({
		singleItem: true,
		responsive: true,
		navigation: false,
		pagination: true,
		navigationText: false,
		autoHeight: false,
		autoPlay: true
	});

	// SETUP THE GALLERY SLIDER
	if ($('#primary-slider #sync1').length > 0) {
		var sync1 = $('#sync1');
		var sync2 = $('#sync2');

		var sync3 = $('#sync3');
		var sync4 = $('#sync4');

		function syncPosition() {
			var current2 = this.currentItem;
			$('#sync2')
				.find('.owl-item')
				.removeClass('synced')
				.eq(current2)
				.addClass('synced');
			if ($('#sync2').data('owlCarousel') !== undefined) {
				center(current2);
			}
			var current3 = this.currentItem;
			$('#sync3')
				.find('.owl-item')
				.removeClass('synced')
				.eq(current3)
				.addClass('synced');
			if ($('#sync3').data('owlCarousel') !== undefined) {
				center(current3);
			}

			var current4 = this.currentItem;
			$('#sync4')
				.find('.owl-item')
				.removeClass('synced')
				.eq(current4)
				.addClass('synced');
			if ($('#sync4').data('owlCarousel') !== undefined) {
				center(current4);
			}
		}

		function center(number) {
			var sync2visible = sync2.data('owlCarousel').owl.visibleItems;
			var sync3visible = sync3.data('owlCarousel').owl.visibleItems;
			var sync4visible = sync4.data('owlCarousel').owl.visibleItems;

			var num = number;
			var found = false;

			for (var i in sync2visible) {
				if (num === sync2visible[i]) {
					var found = true;
				}
			}

			if (found === false) {
				if (num > sync2visible[sync2visible.length - 1]) {
					sync2.trigger('owl.goTo', num - sync2visible.length + 2);
				} else {
					if (num - 1 === -1) {
						num = 0;
					}
					sync2.trigger('owl.goTo', num);
				}
			} else if (num === sync2visible[sync2visible.length - 1]) {
				sync2.trigger('owl.goTo', sync2visible[1]);
			} else if (num === sync2visible[0]) {
				sync2.trigger('owl.goTo', num - 1);
			}
			//3
			for (var i in sync3visible) {
				if (num === sync3visible[i]) {
					var found = true;
				}
			}

			if (found === false) {
				if (num > sync3visible[sync3visible.length - 1]) {
					sync3.trigger('owl.goTo', num - sync3visible.length + 2);
				} else {
					if (num - 1 === -1) {
						num = 0;
					}
					sync3.trigger('owl.goTo', num);
				}
			} else if (num === sync3visible[sync3visible.length - 1]) {
				sync3.trigger('owl.goTo', sync3visible[1]);
			} else if (num === sync3visible[0]) {
				sync3.trigger('owl.goTo', num - 1);
			}

			//4
			for (var i in sync4visible) {
				if (num === sync3visible[i]) {
					var found = true;
				}
			}

			if (found === false) {
				if (num > sync4visible[sync4visible.length - 1]) {
					sync4.trigger('owl.goTo', num - sync4visible.length + 2);
				} else {
					if (num - 1 === -1) {
						num = 0;
					}
					sync4.trigger('owl.goTo', num);
				}
			} else if (num === sync4visible[sync4visible.length - 1]) {
				sync4.trigger('owl.goTo', sync4visible[1]);
			} else if (num === sync4visible[0]) {
				sync4.trigger('owl.goTo', num - 1);
			}
		}

		var sync1options = {
			singleItem: true,
			slideSpeed: 1000,
			navigation: true,
			afterAction: syncPosition,
			responsiveRefreshRate: 200
		};

		var sync2options = {
			singleItem: false,
			items: 3,
			itemsDesktop: [1199, 3],
			itemsDesktopSmall: [979, 3],
			itemsTablet: [768, 8],
			itemsMobile: [479, 4],
			responsiveRefreshRate: 100,
			autoHeight: false,
			navigation: true,
			afterInit: function(el) {
				el.find('.owl-item')
					.eq(0)
					.addClass('synced');
				// console.log('reinitted');
			}
		};

		var sync3options = {
			singleItem: true,
			responsiveRefreshRate: 100,
			navigation: false,
			afterInit: function(el) {
				el.find('.owl-item')
					.eq(0)
					.addClass('synced');
			}
		};
		var sync4options = {
			singleItem: true,
			responsiveRefreshRate: 100,
			navigation: false,
			afterInit: function(el) {
				el.find('.owl-item')
					.eq(0)
					.addClass('synced');
			}
		};

		var syncSlider1 = $('#primary-slider #sync1').data('owlCarousel');
		var syncSlider2 = $('#primary-slider #sync2').data('owlCarousel');
		var syncSlider3 = $('#primary-slider #sync3').data('owlCarousel');
		var syncSlider4 = $('#primary-slider #sync4').data('owlCarousel');
		syncSlider1.reinit(sync1options);
		syncSlider2.reinit(sync2options);
		syncSlider3.reinit(sync3options);
		syncSlider4.reinit(sync4options);

		$('#sync2').on('click', '.owl-item', function(e) {
			e.preventDefault();
			var number = $(this).data('owlItem');
			sync3.trigger('owl.goTo', number);
			sync4.trigger('owl.goTo', number);
			sync1.trigger('owl.goTo', number);
		});
	}

	/***
	 *	FEATURE CAROUSEL
	 *	With further expansion on the options to save code
	 ***/
	$('#features-carousel.type .owl-carousel, #features-carousel.eating .owl-carousel').owlCarousel({
		items: 3,
		itemsDesktop: [1199, 3],
		itemsDesktopSmall: [900, 2],
		itemsTablet: [768, 2],
		itemsMobile: [700, 1],
		pagination: false,
		navigation: true,
		navigationText: false
	});

	var owl = $('#features-carousel.type .owl-carousel, #features-carousel.eating .owl-carousel').data('owlCarousel');

	// Setting options for a 2 column slider
	if ($('#features-carousel.eating .owl-carousel').length > 0) {
		var newOptions = {
			items: 2,
			itemsDesktop: [1199, 2]
		};
		owl.reinit(newOptions);
	}

	if ($('#features-carousel.facilities .owl-carousel').length > 0) {
		var newOptions = {
			items: 6,
			itemsDesktop: [1199, 6],
			itemsDesktopSmall: [900, 4],
			itemsTablet: [768, 3]
		};
		owl.reinit(newOptions);
	}

	$('body').imagesLoaded(function() {
		/***
		 *	SUB CAROUSEL INCORPORATING VIMEO VIDEOS.
		 *
		 ***/
		var owl;

		function getOwl() {
			return $('#sub-carousel').data('owlCarousel');
		}

		function activeHasSlider() {
			return $('.owl-item.active .inner-slider').length > 0;
		}

		function getActiveSly() {
			return $('.owl-item.active .inner-slider').data('sly');
		}

		$('#prev').click(function(event) {
			event.preventDefault();
			$('.owl-item iframe').each(function() {
				iframeSrc = $(this).data('src');
				$(this).attr('src', '');
				$(this).attr('src', iframeSrc);
			});

			if (activeHasSlider()) {
				sly = getActiveSly();

				activeSlide = $('.owl-item.active .inner-slider .active');
				index = sly.getIndex(activeSlide);

				if (index != 0) {
					sly.prev();
					return;
				}
			}

			owl = getOwl();
			owl.prev();
		});

		$('#next').click(function(event) {
			event.preventDefault();
			$('.owl-item iframe').each(function() {
				iframeSrc = $(this).data('src');
				$(this).attr('src', '');
				$(this).attr('src', iframeSrc);
			});

			// if (activeHasSlider()) {
			// 	sly = getActiveSly();

			// 	activeSlide = $('.owl-item.active .inner-slider .active');
			// 	index = sly.getIndex(activeSlide);

			// 	if (index != sly.items.length - 1) {
			// 		sly.next();
			// 		return;
			// 	}
			// }

			owl = getOwl();
			owl.next();
		});

		$('#sub-carousel').owlCarousel({
			singleItem: true,
			responsive: true,
			navigation: true,
			pagination: false,
			navigationText: false,
			autoHeight: false,
			addClassActive: true,
			afterInit: function() {
				var owl = $('#sub-carousel').data('owlCarousel');
			},
			// beforeMove: function() {
			// 	if (activeHasSlider()) {
			// 		sly = getActiveSly();
			// 		sly.slideTo(0);
			// 	}
			// },
			afterMove: function() {},
			afterUpdate: function() {}
		});

		// $('.oneperframe').each(function() {
		// 	var $frame = $(this);
		// 	var $wrap = $frame.parent();

		// 	$('.oneperframe li').css('min-width', $('.right').width());
		// 	// Function to get the Min value in Array
		// 	Array.min = function(array) {
		// 		return Math.min.apply(Math, array);
		// 	};

		// 	var height = $('.oneperframe li img')
		// 		.map(function() {
		// 			return $(this).height();
		// 		})
		// 		.get();

		// 	// SET EACH LI TO BE THE MAX HEIGHT
		// 	$('.oneperframe li').height(Array.min(height));

		// 	// Call Sly on frame
		// 	$frame.sly({
		// 		horizontal: 1,
		// 		itemNav: 'forceCentered',
		// 		smart: 1,
		// 		activateMiddle: 1,
		// 		mouseDragging: 1,
		// 		touchDragging: 1,
		// 		releaseSwing: 1,
		// 		startAt: 0,
		// 		scrollBar: $wrap.find('.scrollbar'),
		// 		scrollBy: 1,
		// 		speed: 300,
		// 		elasticBounds: 1,
		// 		easing: 'easeOutExpo',
		// 		dragHandle: 1,
		// 		dynamicHandle: 1,
		// 		clickBar: 1

		// 		// Buttons
		// 		// prev: $wrap.find('.prev'),
		// 		// next: $wrap.find('.next')
		// 	});

		// 	$(window).resize(function() {
		// 		sly = $('.oneperframe').data('sly');
		// 		$('.oneperframe li').css('min-width', $('.right').width());

		// 		// Function to get the Min value in Array
		// 		Array.min = function(array) {
		// 			return Math.min.apply(Math, array);
		// 		};

		// 		var height = $('.oneperframe li img')
		// 			.map(function() {
		// 				return $(this).height();
		// 			})
		// 			.get();

		// 		// SET EACH LI TO BE THE MAX HEIGHT
		// 		$('.oneperframe li').height(Array.min(height));

		// 		sly.reload();
		// 	});
		// });
	});
})();
// Setting Vars for google maps
var map,
	markers = [],
	infoWindows = [];

/***
 *	GOOGLE MAPS
 ***/
var styles = [
	{
		featureType: 'water',
		elementType: 'all',
		stylers: [{ hue: '#edeff0' }, { saturation: -80 }, { lightness: 73 }, { visibility: 'on' }]
	},
	{
		featureType: 'landscape.man_made',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: -100 }, { lightness: 100 }, { visibility: 'off' }]
	},
	{
		featureType: 'landscape',
		elementType: 'all',
		stylers: [{ hue: '#dddfde' }, { saturation: -89 }, { lightness: -2 }, { visibility: 'simplified' }]
	},
	{
		featureType: 'landscape.natural',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: -100 }, { lightness: 100 }, { visibility: 'off' }]
	},
	{
		featureType: 'road',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: -100 }, { lightness: 100 }, { visibility: 'off' }]
	},
	{
		featureType: 'administrative.province',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: 0 }, { lightness: 100 }, { visibility: 'off' }]
	},
	{
		featureType: 'administrative.locality',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: 0 }, { lightness: 100 }, { visibility: 'off' }]
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: -100 }, { lightness: 100 }, { visibility: 'off' }]
	},
	{
		featureType: 'landscape.man_made',
		elementType: 'all',
		stylers: [{ hue: '#ffffff' }, { saturation: -100 }, { lightness: 100 }, { visibility: 'off' }]
	}
];

function initialize() {
	var mapOptions = {
		mapTypeControlOptions: {
			mapTypeIds: ['Styled']
		},
		zoom: 2,
		center: new google.maps.LatLng(26.58548574678827, 1.0521125793457031),
		mapTypeId: 'Styled'
	};

	map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
	var styledMapType = new google.maps.StyledMapType(styles, { name: 'Styled' });
	map.mapTypes.set('Styled', styledMapType);

	var image = new google.maps.MarkerImage(
		new google.maps.Size(23, 40),
		new google.maps.Point(0, 0),
		new google.maps.Point(0, 40)
	);

	var $marker = $('#locations-markers li[data-lat]');
	$marker.each(function() {
		var lat = $(this).data('lat');
		var lng = $(this).data('long');
		var infoContent = $(this).html();
		addMarker(lat, lng, infoContent);
	});

	var center;

	google.maps.event.addDomListener(map, 'idle', function() {
		center = map.getCenter();
	});
	google.maps.event.addDomListener(window, 'resize', function() {
		map.setCenter(center);
	});

	infoWindows[0].open(map, markers[0]);
}

function addMarker(lat, lng, infoContent) {
	var marker = new google.maps.Marker({
		position: new google.maps.LatLng(lat, lng),
		map: map,
		icon: '/assets/images/legacy/map-icon.png'
	});

	var infowindow = new google.maps.InfoWindow({
		content: infoContent
	});

	google.maps.event.addListener(marker, 'click', function() {
		$(infoWindows).each(function() {
			this.close();
		});

		map.panTo(new google.maps.LatLng(lat, lng));
		infowindow.open(map, marker);
	});

	markers.push(marker);
	infoWindows.push(infowindow);

	return marker;
}

// (function() {
// 	/***
// 	 *
// 	 * Two column by night booking functionality - this is pretty much copy of the booking-bar.js
// 	 *
// 	 * This is used in the Two column by night booking component:
// 	 * If Children are selected age selector is displayed
// 	 * Both selectors show and either one or both are enabled depending how many children selected.
// 	 *
// 	 ***/

// 	var nightDayPiker = createNightDayPicker();
// 	function createNightDayPicker() {
// 		return new Pikaday({
// 			field: document.getElementById('nightDayPiker'),
// 			defaultDate: moment().toDate(),
// 			setDefaultDate: true,
// 			format: 'D/M/YY'
// 		});
// 	}

// 	$('#two-col-children').change(onChangeChildren);

// 	function onChangeChildren(e) {
// 		e.preventDefault();

// 		var children = this.value;
// 		var childAge1 = $(this)
// 			.parents()
// 			.eq(2)
// 			.find('.js-child-1');
// 		var childAge2 = $(this)
// 			.parents()
// 			.eq(2)
// 			.find('.js-child-2');
// 		var ageDisclaimer = $(this)
// 			.parents()
// 			.eq(2)
// 			.find('.booking-bar-disclaimer');

// 		console.log('two col');

// 		if (children == '1') {
// 			ageDisclaimer.css('display', 'none');

// 			childAge1.find('select').prop('disabled', false);

// 			$(this)
// 				.parents()
// 				.eq(3)
// 				.find('.book-containers-bottom')
// 				.removeClass('book-containers-bottom-js');

// 			childAge1.css('display', 'inline-flex');
// 			childAge2.css('display', 'inline-flex');

// 			childAge2.addClass('disabled');
// 			childAge2.find('select').prop('disabled', true);
// 		} else if (children == '2') {
// 			ageDisclaimer.css('display', 'none');

// 			$(this)
// 				.parents()
// 				.eq(3)
// 				.find('.book-containers-bottom')
// 				.removeClass('book-containers-bottom-js');

// 			childAge1.css('display', 'inline-flex');
// 			childAge2.css('display', 'inline-flex');

// 			childAge1.removeClass('disabled');
// 			childAge1.find('select').prop('disabled', false);

// 			childAge2.removeClass('disabled');
// 			childAge2.find('select').prop('disabled', false);
// 		} else {
// 			$(this)
// 				.parents()
// 				.eq(3)
// 				.find('.book-containers-bottom')
// 				.removeClass('book-containers-bottom-js');

// 			childAge1.css('display', 'none');
// 			childAge2.css('display', 'none');
// 			ageDisclaimer.css('display', 'inline-block');

// 			childAge2.addClass('disabled');
// 			childAge2.find('select').prop('disabled', true);

// 			childAge1.addClass('disabled');
// 			childAge1.find('select').prop('disabled', true);
// 		}
// 	}
// })();

// (function() {
// 	/***
// 	 *
// 	 * Booking bar functionality
// 	 *
// 	 * This is used in the Booking Bar:
// 	 * If Children are selected age selector is displayed
// 	 * Both selectors show and either one or both are enabled depending how many children selected.
// 	 *
// 	 * This also deals with sumbitting the form and going back a page. There used to be a problem
// 	 * where form wasn't gettign cleared properly and incorrect values were submitted on -nth submission
// 	 * therefore we're using load() - ajax function to reload the form component.
// 	 * Reference to the dom nodes gets cleared out on ajax
// 	 * So we need to re-instantiate new Pikaday and onChange (show children) with the new dom reference.
// 	 *
// 	 * Sounds more complicated as it is.
// 	 *
// 	 ***/

// 	/*
// 	 * Creates an instance of Pikaday for the booking bar and then re-initiases it
// 	 * when users goes 'back' a page using browser back navigation.
// 	 */

// 	var wasBackButtonClicked = !!window.performance && window.performance.navigation.type === 2;
// 	if (wasBackButtonClicked) {
// 		$('#js-booking-form').load(location.href + ' #js-booking-form', function() {
// 			picker.destroy();

// 			picker = createDatePicker();
// 			$('#children').change(onChange);
// 		});
// 	}

// 	var picker = createDatePicker();
// 	function createDatePicker() {
// 		return new Pikaday({
// 			field: document.getElementById('datepicker'),
// 			format: 'D/M/YYYY'
// 		});
// 	}

// 	$('#children').change(onChange);
// 	$('#children').trigger('change');

// 	function onChange(e) {
// 		e.preventDefault();

// 		var children = this.value;
// 		var childAge1 = $(this)
// 			.parents()
// 			.eq(2)
// 			.find('.js-child-1');
// 		var childAge2 = $(this)
// 			.parents()
// 			.eq(2)
// 			.find('.js-child-2');
// 		var ageDisclaimer = $(this)
// 			.parents()
// 			.eq(2)
// 			.find('.booking-bar-disclaimer');

// 		if (children == '1') {
// 			ageDisclaimer.css('display', 'none');

// 			childAge1.find('select').prop('disabled', false);

// 			childAge1.css('display', 'inline-block');
// 			childAge2.css('display', 'inline-block');

// 			childAge2.addClass('disabled');
// 			childAge2.find('select').prop('disabled', true);
// 		} else if (children == '2') {
// 			ageDisclaimer.css('display', 'none');

// 			childAge1.css('display', 'inline-block');
// 			childAge2.css('display', 'inline-block');

// 			childAge1.removeClass('disabled');
// 			childAge1.find('select').prop('disabled', false);

// 			childAge2.removeClass('disabled');
// 			childAge2.find('select').prop('disabled', false);
// 		} else {
// 			childAge1.css('display', 'none');
// 			childAge2.css('display', 'none');
// 			ageDisclaimer.css('display', 'inline-block');

// 			childAge2.addClass('disabled');
// 			childAge2.find('select').prop('disabled', true);

// 			childAge1.addClass('disabled');
// 			childAge1.find('select').prop('disabled', true);
// 		}
// 	}
// })();

$(document).ready(function() {
	/***
	 *	RESPONSIVE BACKGROUND IMAGE
	 *	We need to make the background image full width and
	 *	responsive but we also need to take up the height of
	 *	the window minus the header
	 ***/
	// function homepageBackstretch() {
	// 	$('#video-container').height(function() {
	// 		// Setup our variables to do calculation with
	// 		var winHeight = $(window).height();
	// 		var headHeight = $('header').height();
	// 		var overallHeight = winHeight - headHeight;

	// 		// Call the bakstretch function
	// 		$('#video-container').backstretch('//s3-eu-west-1.amazonaws.com/trescoisland/images/Homepage/main-home-img.jpg');
	// 		if ($('li.instagram').length > 0) {
	// 			instaPic = $('li.instagram').data('img_url');
	// 			$('li.instagram').backstretch(instaPic);
	// 		}

	// 		$('li.youtube').backstretch('/img/build-imgs/youtube-tile.png');

	// 		// return out actual height based on our calculations
	// 		return overallHeight;
	// 	});
	// }

	// // Call in the homepage backstretch function on initialise
	// homepageBackstretch();

	// $('li.youtube')
	// 	.find('img')
	// 	.wrap('<a href="//www.youtube.com/trescoisland/" title="Visit Our Youtube Channel"></a>');

	/**
	FULL WIDTH VIDEO
	This will house a trigger for the full width video
	on the homepage
	**/
	// var BV;
	// $('.video-cta a').click(function(e) {
	// 	e.preventDefault();
	// 	var videoHolder = $('#video-container');

	// 	videoHolder.find('.video-cta').fadeOut();
	// 	videoHolder.find('.video-controls').fadeIn();

	// 	// Video related stuff
	// 	BV = new $.BigVideo({
	// 		container: videoHolder
	// 	});
	// 	BV.init();
	// 	BV.show('//player.vimeo.com/external/84304318.hd.mp4?s=6589a3a65d2ceea145080154e8bd2fb0');

	// 	$('#big-video-wrap').append($('.video-controls').html());
	// 	BV.getPlayer().on('ended', function() {
	// 		var offsetThis = $('#content-body').offset();
	// 		$('body, html').animate(
	// 			{
	// 				scrollTop: offsetThis.top - 85
	// 			},
	// 			1000
	// 		);
	// 	});
	// });

	// if ($('#social-footer').length > 0) {
	// 	$.ajax({
	// 		url: 'ajax/home-social'
	// 	}).done(function(data) {
	// 		$('#social-footer').html(data);
	// 	});
	// }

	// Video control buttons
	// $('.video-controls .play').click(function() {
	// 	BV.getPlayer().play(100);
	// });

	// $('.video-controls .pause').click(function() {
	// 	BV.getPlayer().pause(100);
	// });

	// $('.video-controls .mute').click(function() {
	// 	if ($(this).hasClass('volume')) {
	// 		BV.getPlayer().volume(100);
	// 		$(this).removeClass('volume');
	// 	} else {
	// 		BV.getPlayer().volume(0);
	// 		$(this).addClass('volume');
	// 	}
	// });

	// function firstOptionSearch() {
	// 	if ($(window).width() < 480) {
	// 		$('#generic_search option:first').text('Select a Property');
	// 	} else {
	// 		$('#generic_search option:first').text("Please select the property you're interested in");
	// 	}
	// }

	// firstOptionSearch();

	// $(window).resize(function() {
	// 	firstOptionSearch();
	// });

	/***
	 *	STICKY NAV CLASS ADDITION
	 *	Instead of using a rather bulky jQuery script
	 *	we can add a class to the header on scroll :-)
	 ***/

	//caches a jQuery object containing the header element
	// $(function() {
	// 	var header = $('.animate-container');
	// 	$(window).scroll(function() {
	// 		var scroll = $(window).scrollTop();

	// 		if (scroll >= 200) {
	// 			header.removeClass('fixed-header').addClass('sticky-header');
	// 			$('.scroll-contain').css('top', '-10px');
	// 		} else {
	// 			header.removeClass('sticky-header').addClass('fixed-header');
	// 			$('.scroll-contain').css('top', '+46px');
	// 		}
	// 	});
	// });

	/***
	 *	SCROLL FADE
	 *	Fade out video CTA on scroll
	 ***/

	//attach some code to the scroll event of the window object
	//or whatever element(s) see http://docs.jquery.com/Selectors
	// var fadeStart = 100, // 100px scroll or less will equiv to 1 opacity
	// 	fadeUntil = 800, // 200px scroll or more will equiv to 0 opacity
	// 	fading = $('.video-cta');

	// $(window).bind('scroll', function() {
	// 	var offset = $(document).scrollTop(),
	// 		opacity = 0;
	// 	if (offset <= fadeStart) {
	// 		opacity = 1;
	// 	} else if (offset <= fadeUntil) {
	// 		opacity = 1 - offset / fadeUntil;
	// 	}
	// 	fading.css('opacity', opacity);
	// });

	// Change URL on change of select
	// $('.property-select select').change(function() {
	// 	selectedValue = $(this).val();

	// 	window.location.href = '/staying-on-tresco/property-list/' + selectedValue;
	// });

	// Dynamic Select Box Sorting (cottage name etc)

	// $('select#freeform_cottage_name').each(function() {
	// 	var options = $(this).children('option');
	// 	options.sort(function(optionA, optionB) {
	// 		return optionA.text.localeCompare(optionB.text);
	// 	});
	// 	$(this)
	// 		.empty()
	// 		.append(options);
	// 	$('#freeform_cottage_name').prepend('<option selected>Select a cottage</option>');

	// 	$(this).val($('select option:first').val());
	// });
	// $('select#freeform_country').val($('select option:first').val());
	// $('#freeform_country option[value="gb"]').attr('selected', 'selected');

	/***
	 *	ISSUU RESPONSIVE FIXES
	 *
	 ***/

	var $issu = $('#issu');

	function setIssuHeight() {
		var issuHeight = $issu.parent().outerHeight();
		var issuWidth = $issu.parent().width();

		$issu.children(0).css({ height: issuHeight, width: issuWidth, 'min-height': 0 });
	}

	if ($issu.length > 0) {
		setIssuHeight();

		$(window).on('resize', function() {
			setIssuHeight();
		});
	}

	/**
	 * PLACEHOLDER FIXES
	 */

	// var placeholderSupport = 'placeholder' in document.createElement('input');
	// if (!placeholderSupport) {
	// 	//This browser does not support the placeholder attribute
	// 	//use javascript instead
	// 	$('[placeholder]')
	// 		.focus(function() {
	// 			var input = $(this);
	// 			if (input.val() === input.attr('placeholder')) {
	// 				input.val('');
	// 				input.removeClass('placeholder');
	// 			}
	// 		})
	// 		.blur(function() {
	// 			var input = $(this);
	// 			if (input.val() === '' || input.val() === input.attr('placeholder')) {
	// 				input.addClass('placeholder');
	// 				input.val(input.attr('placeholder'));
	// 			}
	// 		})
	// 		.blur()
	// 		.parents('form')
	// 		.submit(function() {
	// 			$(this)
	// 				.find('[placeholder]')
	// 				.each(function() {
	// 					var input = $(this);
	// 					if (input.val() === input.attr('placeholder')) {
	// 						input.val('');
	// 					}
	// 				});
	// 		});
	// }

	/***
	 *	SLY SLIDER
	 *	Used on individual property pages
	 ***/
	var $frame = $('#crazy');
	var $slidee = $frame.children('ul').eq(0);
	var $wrap = $frame.parent();

	// Call Sly on frame
	//

	if ($frame.length > 0) {
		$('body').imagesLoaded(function() {
			function thisHeight() {
				return $(this).height();
			}

			$('#crazy li').css('max-width', $('#crazy').width());
			// Function to get the Min value in Array
			Array.min = function(array) {
				return Math.min.apply(Math, array);
			};

			var height = $('#crazy li img')
				.map(function() {
					return $(this).height();
				})
				.get();

			// SET EACH LI TO BE THE MAX HEIGHT
			$('#crazy li').height(Array.min(height));
			$frame.sly({
				horizontal: 1,
				itemNav: 'basic',
				smart: 1,
				activateOn: 'click',
				mouseDragging: 1,
				touchDragging: 1,
				releaseSwing: 1,
				startAt: 0,
				scrollBar: $wrap.find('.scrollbar'),
				scrollBy: 0,
				pagesBar: $wrap.find('.pages'),
				activatePageOn: 'click',
				speed: 300,
				elasticBounds: 1,
				easing: 'easeOutExpo',
				dragHandle: 1,
				dynamicHandle: 1,
				clickBar: 1,

				// Buttons
				forward: $wrap.find('.forward'),
				backward: $wrap.find('.backward'),
				prev: $wrap.find('.prev'),
				next: $wrap.find('.next'),
				prevPage: $wrap.find('.prevPage'),
				nextPage: $wrap.find('.nextPage')
			});
		});

		// CREATING A RESIZE FUNCTION
		$(window).resize(function() {
			sly = $('#crazy').data('sly');
			$('#crazy li').css('max-width', $('#crazy').width());

			// Function to get the Min value in Array
			Array.min = function(array) {
				return Math.min.apply(Math, array);
			};

			var height = $('#crazy li img')
				.map(function() {
					return $(this).height();
				})
				.get();

			// SET EACH LI TO BE THE MAX HEIGHT
			$('#crazy li').height(Array.min(height));

			sly.reload();
		});
	}

	/**
	 * DYNAMICALLY KEEP THE HEIGHT THE SAME
	 */
	$('body').imagesLoaded(function() {
		var maxHeight = -1;

		$(
			'#promotions-section.promotions .information-panels .panel .panel-content, #promotions-section.events .panel-content '
		).each(function() {
			maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
		});

		$(
			'#promotions-section.promotions .information-panels .panel .panel-content, #promotions-section.events .panel-content'
		).each(function() {
			$(this).height(maxHeight);
		});
	});

	/***
	 *	SLIDING OVERLAY
	 *	Create a function for the sliding overlay
	 *	on the homepage **UPDATE**
	 ***/
	function slidingOverlay() {
		var winHeight = $(window).height();
		var headHeight = $('header').height();
		var overallHeight = winHeight + headHeight;
		var minusNumber = 160;

		if ($(window).width() < 768) {
			minusNumber = headHeight;
		}

		$('#content-body').css({
			marginTop: overallHeight - headHeight - 10
		});

		$('.arriving-promo').height(winHeight - headHeight);

		// Arriving back stretch
		$('.arriving-promo').each(function() {
			$(this).backstretch($(this).data('image'));
		});

		if ($(window).width() > 768) {
			$.stellar({
				responsive: true,
				horizontalScrolling: false,
				hideDistantElements: false
			});
		}
	}

	slidingOverlay();

	// Now the responsive bit
	$(window).resize(function() {
		// homepageBackstretch();
		slidingOverlay();
		$.stellar('refresh');
	});

	// Discover more on click scroll to welcome section
	// $('#content-body .discover-overlay').click(function() {
	// 	var offsetThis = $('#content-body').offset();
	// 	$('body, html').animate(
	// 		{
	// 			scrollTop: offsetThis.top - 153
	// 		},
	// 		1000
	// 	);
	// });

	// $('.availability-grid').each(function() {
	// 	$(this)
	// 		.find('tr:gt(3)')
	// 		.hide();
	// });

	// var years = new Array();

	// $('.availability-grid, .availability-table').each(function(){
	// 	$(this).find('td, div').each(function(){
	// 		if($(this).data('year')){
	// 			year = $(this).data('year');
	// 			years.push(year);
	// 			output = $.unique(years);

	// 			$(this).parents('.availability-grid, .availability-table').find('.year-indicator').text(output);
	// 		}
	// 	});

	// });

	// $('.availability-grid .show-more').click(function(e) {
	// 	if ($(this).hasClass('active')) {
	// 		$(this).removeClass('active');
	// 		$(this).html('Show More <i class="down-arrow"></i>');
	// 		$(this)
	// 			.parent()
	// 			.find('tr:gt(2)')
	// 			.fadeOut();
	// 	} else {
	// 		$(this).addClass('active');
	// 		$(this).html('Show Less <i class="up-arrow"></i>');
	// 		$(this)
	// 			.parent()
	// 			.find('tr:gt(2)')
	// 			.fadeIn();
	// 	}

	// 	e.preventDefault();
	// });

	// $('.availability-table').each(function() {
	// 	$(this)
	// 		.find('li:gt(5)')
	// 		.hide();
	// });

	// $('.availability-table .show-more').click(function(e) {
	// 	if ($(this).hasClass('active')) {
	// 		$(this).removeClass('active');
	// 		$(this).html('Show More <i class="down-arrow"></i>');
	// 		$(this)
	// 			.parent()
	// 			.find('li:gt(5)')
	// 			.fadeOut();
	// 	} else {
	// 		$(this).addClass('active');
	// 		$(this).html('Show Less <i class="up-arrow"></i>');
	// 		$(this)
	// 			.parent()
	// 			.find('li:gt(5)')
	// 			.fadeIn();
	// 	}

	// 	e.preventDefault();
	// });

	// $('.staying-index-search #when #item-2').attr('selected', 'selected');

	/***
	 *	NAVIGATION MENU
	 *	On Window.resize() if window.width < 768 hide nav, then on
	 *	click show the navigation (slideDown()). if window.width is
	 *	greater than 768 show navigation
	 ***/

	$('.navigation-trigger').click(function() {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');

			$('.navigation-container').removeClass('active');
		} else {
			$(this).addClass('active');

			$('.navigation-container').addClass('active');
		}
	});

	$(window).scroll(function() {
		hideNav();
	});

	$('#main-navigation').hover(
		function() {
			showNav();
		},
		function() {
			hideNav();
		}
	);

	function showNav() {
		$('#sub-navigation span.bg-image')
			.stop()
			.fadeIn();
		$('#sub-navigation')
			.stop()
			.fadeIn();
	}

	function hideNav() {
		$('#sub-navigation span.bg-image')
			.stop()
			.fadeOut();
		$('#sub-navigation')
			.stop()
			.fadeOut();
	}

	/***
	 *	CONTACT ISLANDER TRIGGER
	 *	On click of 'talk to an islander', open the
	 *	talk-to-islander box above header
	 ***/
	if ($('html').hasClass('lt-ie9')) {
		$('.islander-trigger').click(function() {
			var animateContainer = $('.animate-container');

			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$('#talk-to-islander').css({ top: -170, position: 'fixed' });
				$('#sub-navigation').css({ top: '100%' });
				$(this).css('top', '0');
			} else {
				$(this).addClass('active');
				$(animateContainer).slideDown();
				$('#talk-to-islander').css({ top: 0, position: 'static' });
				$('#sub-navigation').css({ top: '90%' });
				$(this).css('top', '160');
			}
		});
	} else if ($(window).width() > 766) {
		$('.islander-trigger').click(function() {
			var animateContainer = $('.animate-container');

			if (animateContainer.hasClass('bounceInDown')) {
				$(animateContainer).addClass('bounceOutUp');
				$(animateContainer).removeClass('bounceInDown');
				$(this).addClass('deactive');
				$(this).removeClass('active');
			} else {
				$(this).addClass('active');
				$(this).removeClass('deactive');
				$(animateContainer).addClass('bounceInDown');
				$(animateContainer).removeClass('bounceOutUp');
			}
		});
	}

	/***
	 *	ARRIVING - Discover Content Tabs
	 *
	 *
	 ***/
	// $('.arriving-promo .discover-overlay').click(function() {
	// 	if ($(this).hasClass('not-triggered')) {
	// 		$(this)
	// 			.removeClass('not-triggered')
	// 			.addClass('triggered fadeInUp');
	// 		$(this)
	// 			.parent()
	// 			.addClass('triggered');
	// 		$(this)
	// 			.parents('.discover-section')
	// 			.find('.discover-content')
	// 			.addClass('triggered fadeInUp')
	// 			.removeClass('not-triggered fadeInDown');
	// 	} else {
	// 		$(this)
	// 			.removeClass('triggered')
	// 			.addClass('not-triggered');
	// 		$(this)
	// 			.parent()
	// 			.removeClass('triggered');
	// 		$(this)
	// 			.parents('.discover-section')
	// 			.find('.discover-content')
	// 			.addClass('not-triggered fadeInDown')
	// 			.removeClass('fadeInUp triggered');
	// 	}
	// });

	// $('.intro-content .drop-content').click(function() {
	// 	if (
	// 		$(this)
	// 			.find('.inner-content')
	// 			.hasClass('active')
	// 	) {
	// 		$(this).removeClass('active');
	// 		$(this)
	// 			.find('.inner-content')
	// 			.removeClass('active')
	// 			.fadeOut()
	// 			.slideUp();
	// 		$(this)
	// 			.parents('.arriving-promo')
	// 			.height(function() {
	// 				height =
	// 					$(this).height() -
	// 					$(this)
	// 						.find('.inner-content')
	// 						.height();
	// 				return height;
	// 			});
	// 		$(this)
	// 			.parents('.arriving-promo')
	// 			.backstretch('resize');
	// 	} else {
	// 		$(this).addClass('active');
	// 		$(this)
	// 			.find('.inner-content')
	// 			.addClass('active')
	// 			.fadeIn()
	// 			.slideDown(function() {
	// 				$(this)
	// 					.parents('.arriving-promo')
	// 					.height(function() {
	// 						height =
	// 							$(this).height() +
	// 							$(this)
	// 								.find('.inner-content')
	// 								.height();
	// 						return height;
	// 					});
	// 				$(this)
	// 					.parents('.arriving-promo')
	// 					.backstretch('resize');
	// 			});
	// 	}
	// });

	/***
	 *	SUB NAVIGATION
	 *	Making a trigger action for the sub navigation
	 *	within the sidebar
	 ***/
	// $('.sub-nav').click(function() {
	// 	if ($(this).hasClass('active')) {
	// 		$(this)
	// 			.removeClass('active')
	// 			.parents('nav')
	// 			.find('ul')
	// 			.slideUp()
	// 			.removeClass('active');
	// 	} else {
	// 		$(this)
	// 			.addClass('active')
	// 			.parents('nav')
	// 			.find('ul')
	// 			.slideDown()
	// 			.addClass('active');
	// 	}
	// });

	/***
	*	ACCORDION TRIGGER
	*	Used throughout the site for form reveals etc
	*	but also used on the search results page hence
	*	the extra code
	***/
	var $accordionBody = '';

	// <div class="accordion-trigger clearfix">
	//     <span>{form_label} </span>
	//     <a href="#openform" class="indicate" data-formid="{form_id}">Open</a>
	// </div>
	// <div class="accordion-body" id="form_holder-{form_id}"></div>


	$('.accordion-trigger').click(function(){
		// Set up some variables dependent on a class of the trigger

		if($(this).hasClass('drop')){
			$accordionBody = $(this).prev("div");
		} else {
			$accordionBody = $(this).next("div");
		}

		var formId = $(this).attr('data-formid');
		var returnUrl = $(this).attr('data-return');

		// Do a check to see if it's visible or not
		if($accordionBody.is(":visible")){

			slideAccordianUp($(this), $accordionBody)

		} else {
			// Close all of the accordions and change this particular text for the trigger
			$(".accordion-body:visible").each(function(){
				slideAccordianUp($(this).siblings('.accordion-trigger'), $(this))
			});

			$(this).find('.indicate').text('Close');

			if(formId && $accordionBody.html() == '') {
				$accordionBody.html('<div class="loading-form">Please Wait....<i class="loading"></i></div>')
				$accordionBody.slideDown('slow');
				$accordionBody.load('/ajax/form/'+formId+'/'+returnUrl+'/', function() {
					/* We do a check to see if the trigger has a class of result & is empty as we use
					*  the accordion elsewhere throughout the site that doesn't do what we require */
					if($(this).hasClass('result') && $accordionBody.html().length === 0){
						var entryid = $(this).data('entryid');
					} else {
						$(this).find('form').fadeIn();
						// enableDatePick();
					}

					if($('.js-wine-description').length) {
						$('.js-wine-description').on("click", function(event) {
							event.preventDefault();
							$(this).next().slideToggle();
						})
					}
				});
			} else {
				/* We do a check to see if the trigger has a class of result & is empty as we use
				*  the accordion elsewhere throughout the site that doesn't do what we require */
				if($(this).hasClass('result') && $accordionBody.html().length === 0){
					var entryid = $(this).data('entryid');
				} else {
					$accordionBody.slideDown('slow');
					// enableDatePick();
				}
			}
		}

		function slideAccordianUp($trigger, $accordian) {
			$accordian.slideUp("slow", function(){
				$accordian.removeClass('triggered');
				$trigger.parent().find('.indicate').text('Open');
			});

			$trigger.removeClass('triggered');

			if(formId && $accordian.html() != '') { $accordian.html(''); }
		}
	});


	/***
	 *	ILLUSTRATED MAP MARKERS
	 *	Making a trigger action for illustrated map
	 *	markers
	 ***/
	if ($(window).width() > 767) {
		$('.pointer').click(function() {
			$('.generic-content.welcome').fadeOut();

			$('.pointer-information')
				.fadeOut()
				.removeClass('active');
			var getData = $(this).data('id');
			$('.pointer-information.' + getData)
				.fadeIn()
				.addClass('active');
		});

		if ($('#illustrated-map.enjoying').length > 0) {
			var getData = $('.pointer')
				.last()
				.data('id');
			$('.pointer-information' + getData)
				.fadeIn()
				.addClass('active');
		}

		if ($('#illustrated-map.eating-on-tresco').length > 0) {
			setTimeout(function() {
				$('.pointer-information.ruin')
					.fadeIn()
					.addClass('active');
			}, 5000);
		}

		$('#illustrated-map .generic-content.welcome').click(function(event) {
			$(this).fadeOut();
		});
	}

	/***
	 *	IMAGE COLLAGE HOVER
	 *
	 ***/
	// $('.instagram').hover(
	// 	function() {
	// 		$(this)
	// 			.find('.overlay')
	// 			.stop()
	// 			.animate({
	// 				height: '100%',
	// 				opacity: '1'
	// 			});
	// 	},
	// 	function() {
	// 		$(this)
	// 			.find('.overlay')
	// 			.stop()
	// 			.animate({
	// 				height: '0',
	// 				opacity: '0'
	// 			});
	// 	}
	// );

	/**
	 * BOOKING FORM
	 */
	// $('#page-wrapper.booking-form #freeform_cottage_name').val($('.hidden-id').html());

	/***
	 *	GOOGLE MAP MARKERS
	 *
	 ***/

	if ($('#map-canvas').length > 0) {
		initialize();
	}

	/***
	 *	FORM JAVASCRIPT
	 ***/
	// function enableDatePick() {
	// 	$('.datepick').datetimepicker({
	// 		timepicker: false,
	// 		format: 'd/m/Y'
	// 	});
	// 	$('select#freeform_country').val($('select option:first').val());
	// 	$('#freeform_country option[value="gb"]').attr('selected', 'selected');
	// 	$('label').each(function() {
	// 		if ($(this).hasClass('required')) {
	// 			$(this)
	// 				.parent()
	// 				.find('input')
	// 				.attr('required', true);
	// 		}
	// 	});

	// 	if ($('accordion-body .generic-form').length > 0) {
	// 		$('.accordion-body .generic-form').validate();
	// 	}

	// 	var dateNow = new Date();
	// 	$('.arrival-date').datetimepicker({
	// 		minDate: '-1970/12/28',
	// 		timepicker: false,
	// 		format: 'd/m/Y'
	// 	});
	// }

	// enableDatePick();

	// $('#freeform_field_16, #freeform_field_23').datetimepicker({
	// 	format: 'Y/m/d',
	// 	timepicker: false
	// });
	// $('#freeform_field_17, #freeform_field_25').datetimepicker({
	// 	format: 'Y/m/d',
	// 	onShow: function(ct) {
	// 		this.setOptions({
	// 			minDate: $('#freeform_field_16, #freeform_field_23').val()
	// 		});
	// 	},
	// 	timepicker: false
	// });

	// $('.search-dropdown select').change(function() {
	// 	this.form.submit();
	// });

	// $('.search-dropdown .submit-btn').on('click', function() {
	// 	var dropValue = $('.dropdown').val();
	// 	if (dropValue.length < 1) {
	// 		$('.js-error').text('Please select a cottage from the dropdown.');
	// 		$('.js-error').addClass('error-msg');
	// 		$('.moz-select-fix').css('margin-top', '-15px');
	// 	} else {
	// 		$('.generic-search').submit();
	// 	}
	// });

	// $('body').on('change', '.second-input input[type="checkbox"]', function() {
	// 	if ($(this).is(':checked')) {
	// 		$(this)
	// 			.parent()
	// 			.find('.secondary-input')
	// 			.addClass('active');
	// 	} else {
	// 		$(this)
	// 			.parent()
	// 			.find('.secondary-input')
	// 			.removeClass('active');
	// 	}
	// });

	// // Need to duplicate fields for cyclists details etc..
	// $('body').on('click', 'button.add-option', function(e) {
	// 	e.preventDefault();
	// 	var count = $('.option').length;
	// 	$cloneOption = $(this)
	// 		.parent()
	// 		.find('.option')
	// 		.last()
	// 		.clone()
	// 		.insertAfter(
	// 			$(this)
	// 				.parent()
	// 				.find('.option:last')
	// 		);

	// 	// Reset the values of theinput types
	// 	$cloneOption.find('input, select').val('');
	// 	$cloneOption.find('input[type="checkbox"]').removeAttr('checked');
	// 	$cloneOption.find('input[type="radio"]').removeAttr('checked');
	// 	$cloneOption.find('.datepick').datetimepicker({
	// 		timepicker: false,
	// 		format: 'd/m/Y'
	// 	});

	// 	$cloneOption
	// 		.find('.column')
	// 		.children()
	// 		.each(function() {
	// 			elementId = $(this).attr('id');
	// 			elementName = $(this).attr('name');
	// 			elementLabel = $(this).attr('for');
	// 			if (elementId) {
	// 				replaceId = elementId.replace(/\[[0-9]+\]/, '[' + count + ']');
	// 				$(this).attr('id', replaceId);
	// 			}
	// 			if (elementName) {
	// 				replaceName = elementName.replace(/\[[0-9]+\]/, '[' + count + ']');
	// 				$(this).attr('name', replaceName);
	// 			}

	// 			if (elementLabel) {
	// 				replaceLabel = elementLabel.replace(/\[[0-9]+\]/, '[' + count + ']');
	// 				$(this).attr('for', replaceLabel);
	// 			}
	// 		});
	// });

	// Dynamically fetch the tide times uses rss2json.com api
	function tideTimesInit() {
		var lowTides = [],
			time,
			highTides = [];
		function pad(n, size) {
			var s = String(n);
			while (s.length < (size || 2)) {
				s = '0' + s;
			}
			return s;
		}

		var feed = new google.feeds.Feed('https://www.tidetimes.org.uk/st-marys-tide-times.rss');
		feed.load(function(result) {
			if (!result.error) {
				for (var i = 0; i < result.feed.entries.length; i++) {
					var content = result.feed.entries[i].content;
					var explode = content.split('<br>');
					$.each(explode, function(i, str) {
						if (str.match(/(Low)/g)) {
							time = str.match(/(\d\d):(\d\d)/);
							var d = new Date();
							d.setHours(time[1]);
							d.setMinutes(time[2]);
							lowTides.push(pad(d.getHours(), 2) + ':' + pad(d.getMinutes(), 2));
						}
						if (str.match(/(High)/g)) {
							time = str.match(/(\d\d):(\d\d)/);
							var d = new Date();
							d.setHours(time[1]);
							d.setMinutes(time[2]);
							highTides.push(pad(d.getHours(), 2) + ':' + pad(d.getMinutes(), 2));
						}
					});
				}

				$.each(lowTides.slice(-2), function(i) {
					$('.tide-times .low-tide').append('<span class="tide-' + i + '">' + this + '</span>');
				});
				$.each(highTides.slice(-2), function(i) {
					$('.tide-times .high-tide').append('<span class="tide-' + i + '">' + this + '</span>');
					if (highTides.length == 1) {
						$('.high-tide span').addClass('single');
					}
				});
			}
		});
	}
	google.setOnLoadCallback(tideTimesInit);

	// 3 WHITE HATS JQUERY
	if (typeof jQuery != 'undefined') {
		jQuery(document).ready(function($) {
			var filetypes = /\.(zip|exe|pdf|doc*|xls*|ppt*|mp3)$/i;
			var baseHref = '';
			if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');
			jQuery('a').each(function() {
				var href = jQuery(this).attr('href');

				if (href && href.match(/^https?\:/i) && !href.match(document.domain)) {
					jQuery(this).click(function() {
						var extLink = href.replace(/^https?\:\/\//i, '');

						_gaq.push(['_trackEvent', 'External', 'Click', extLink]);

						if (
							jQuery(this).attr('target') != undefined &&
							jQuery(this)
								.attr('target')
								.toLowerCase() != '_blank'
						) {
							setTimeout(function() {
								location.href = href;
							}, 200);

							return false;
						}
					});
				} else if (href && href.match(/^mailto\:/i)) {
					jQuery(this).click(function() {
						var mailLink = href.replace(/^mailto\:/i, '');

						_gaq.push(['_trackEvent', 'Email', 'Click', mailLink]);
					});
				} else if (href && href.match(filetypes)) {
					jQuery(this).click(function() {
						var extension = /[.]/.exec(href) ? /[^.]+$/.exec(href) : undefined;

						var filePath = href;

						_gaq.push(['_trackEvent', 'Download', 'Click-' + extension, filePath]);

						if (
							jQuery(this).attr('target') != undefined &&
							jQuery(this)
								.attr('target')
								.toLowerCase() != '_blank'
						) {
							setTimeout(function() {
								location.href = baseHref + href;
							}, 200);

							return false;
						}
					});
				}
			});
		});
	}

	/*
	 *	Radio Button Select
	 */
	// $('#payment_type input').change(function() {
	// 	if ($(this).attr('id') == 'timeshare') {
	// 		$('.timeshare-details')
	// 			.fadeIn()
	// 			.removeClass('hidden');
	// 	} else {
	// 		$('.timeshare-details')
	// 			.fadeOut()
	// 			.addClass('hidden');
	// 	}
	// 	if ($(this).attr('id') == 'cottage') {
	// 		$('.cottage-details')
	// 			.fadeIn()
	// 			.removeClass('hidden');
	// 	} else {
	// 		$('.cottage-details')
	// 			.fadeOut()
	// 			.addClass('hidden');
	// 	}
	// 	if ($(this).attr('id') == 'apartment') {
	// 		$('.apartment-details')
	// 			.fadeIn()
	// 			.removeClass('hidden');
	// 	} else {
	// 		$('.apartment-details')
	// 			.fadeOut()
	// 			.addClass('hidden');
	// 	}
	// 	if ($(this).attr('id') == 'cottage-bill') {
	// 		$('.cottage-bill-details')
	// 			.fadeIn()
	// 			.removeClass('hidden');
	// 	} else {
	// 		$('.cottage-bill-details')
	// 			.fadeOut()
	// 			.addClass('hidden');
	// 	}
	// 	if ($(this).attr('id') == 'electricity') {
	// 		$('.electricity-details')
	// 			.fadeIn()
	// 			.removeClass('hidden');
	// 	} else {
	// 		$('.electricity-details')
	// 			.fadeOut()
	// 			.addClass('hidden');
	// 	}
	// });

	// $('.js-wine-description').on('click', function() {
	// 	alert('press works');
	// });
}); // End document.ready

/*
 *    Lightbox - used with 'by nights' booking in sn_two-col-booking and sn_booking-bar-days.
 */
// $(document).ready(function() {
// 	$('.js-lightbox-close').click(function(e) {
// 		e.preventDefault();
// 		$('.lightbox').removeClass('lightbox-opened');
// 		$('body').css('overflow', 'auto');
// 	});

// 	$(document).keydown(function(e) {
// 		if (e.keyCode == 27) {
// 			$('.lightbox').removeClass('lightbox-opened');
// 			// $('body').css('overflow', 'auto');
// 		}
// 	});

// 	$('#js-booking-form').submit(function(e) {
// 		e.preventDefault();

// 		var nights = $(this)
// 			.find('.js-select-nights')
// 			.val();
// 		if (nights >= 4) {
// 			$('.lightbox').addClass('lightbox-opened');
// 			$('body').css('overflow', 'hidden');
// 		} else {
// 			this.submit();
// 		}
// 	});

// 	$('.js-lightbox-continue').click(function() {
// 		$('#js-booking-form')[0].submit();
// 	});
// });
